import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { IconModule } from "../icon";

import { GrowlContainerComponent } from "./growl-container.component";
import { GrowlNoticeComponent } from "./growl-notice.component";

/**
 * Module for the growl components
 * Providers are defined in {@link GrowlServiceModule}
 */
@NgModule({
  imports: [CommonModule, IconModule],
  declarations: [GrowlContainerComponent, GrowlNoticeComponent],
  entryComponents: [GrowlContainerComponent]
})
export class GrowlComponentsModule {}
